import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Dropdown from '../../../components/Dropdown'
import InternalLink from '../../../components/InternalLink'
import { ReactComponent as DotsIcon } from '../../../assets/icons/dots-menu.svg'

import useStyles from './style'

const ActionsDropdown = React.memo(({ options, className, actionsListWrapperClassName, closeOnInsideClick }) => {
  const classes = useStyles(options)

  const { t } = useTranslation()

  return (
    <div className={classnames(classes.dropdownWrapper, className)} data-html2canvas-ignore>
      <Dropdown
        className={classes.dropdown}
        placement="bottom-end"
        offset={[-8, 3]}
        triggerElement={
          <button type="button" className={classes.actionsBtn}>
            <DotsIcon />
          </button>
        }
        closeOnInsideClick={closeOnInsideClick}
      >
        <div className={actionsListWrapperClassName}>
          <ul className={classes.actionsList}>
            {options &&
              options.map((option, index) =>
                option.link ? (
                  option.isItemLinkExternal ? (
                    <a
                      key={index}
                      href={option.link}
                      target="_blank"
                      rel="noreferrer nofollow"
                      aria-disabled={true}
                      className={classnames(
                        classes.actionsLink,
                        classes.actionsItem,
                        !option.link && classes.actionsItemDisabled
                      )}
                    >
                      {t(option.text)}
                    </a>
                  ) : (
                    <InternalLink
                      className={classnames(classes.actionsItem, classes.actionsLink)}
                      to={option.link}
                      key={index}
                    >
                      {t(option.text)}
                    </InternalLink>
                  )
                ) : (
                  <li className={classes.actionsItem} key={index} onClick={option.onClickHandler}>
                    {t(option.text)}
                  </li>
                )
              )}
          </ul>
        </div>
      </Dropdown>
    </div>
  )
})

ActionsDropdown.propTypes = {
  options: PropTypes.array,
  className: PropTypes.string,
  closeOnInsideClick: PropTypes.bool
}

export default ActionsDropdown
